import { FunctionComponent, CSSProperties } from "react";
import { RetweetOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

interface ReinscriptionBadgeProps {
    /** Marge / positionnement optionnel selon le contexte d'affichage */
    style?: CSSProperties;
}

/**
 * Petit badge « pilule » mis en avant à côté du nom de l'élève lorsqu'une
 * inscription provient du processus de réinscription dédié.
 *
 * Le violet/indigo est volontairement distinct des couleurs de statut
 * (vert / orange / rouge / gris) pour éviter toute confusion visuelle.
 */
export const ReinscriptionBadge: FunctionComponent<ReinscriptionBadgeProps> = ({ style }) => (
    <Tooltip title="Cette inscription a suivi le processus de réinscription">
        <span className="reinscription-badge" style={style}>
            <RetweetOutlined />
            Réinscription
        </span>
    </Tooltip>
);
